document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-bold-theme-toggle]');
  if (!btn) return;
  var root = document.documentElement;
  var isLight = root.getAttribute('data-bold-theme') === 'light';
  var next = isLight ? 'dark' : 'light';
  if (next === 'light') {
    root.setAttribute('data-bold-theme', 'light');
  } else {
    root.removeAttribute('data-bold-theme');
  }
  try {
    localStorage.setItem('bold-theme', next);
  } catch (err) {}
  document.querySelectorAll('[data-bold-theme-label]').forEach(function (el) {
    el.textContent = next === 'light' ? 'Oscuro' : 'Claro';
  });
});

function setBoldNavOpen(header, open) {
  header.setAttribute('data-nav-open', open ? 'true' : 'false');
  var burger = header.querySelector('[data-bold-nav-toggle]');
  if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  document.documentElement.style.overflow = open ? 'hidden' : '';
}

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-bold-nav-toggle]');
  if (btn) {
    var header = btn.closest('.bold-header');
    if (!header) return;
    var open = header.getAttribute('data-nav-open') === 'true';
    setBoldNavOpen(header, !open);
    return;
  }
  var backdrop = e.target.closest('[data-bold-nav-backdrop]');
  if (backdrop) {
    setBoldNavOpen(backdrop.closest('.bold-header'), false);
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var header = document.querySelector('.bold-header[data-nav-open="true"]');
  if (header) setBoldNavOpen(header, false);
});
